import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { utils } from '@sfaas/util';

export default {
	fetchStations: ({ params, currentPage, pageUnit }) => {
		const { plantCd, ...rest } = params;
		const queryParams = utils.$sf_objectToQueryString({ ...rest, currentPage, pageUnit });

		return client
			.get(`${BASE_URL}/station/v1/plants/${plantCd}/stations?${queryParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	getCommCds: ({ plantCd, commCdType }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	getStnCd: ({ plantCd, shopCd }) => {
		return client
			.get(`${BASE_URL}/station/v1/plants/${plantCd}/stnCds?shopCd=${shopCd}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	register: ({ station }) => {
		const { plantCd, stnCd } = station;
		return client
			.post(`${BASE_URL}/station/v1/status/1/plants/${plantCd}/stations/${stnCd}`, station)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	modify: ({ station }) => {
		const { plantCd, stnCd } = station;
		return client
			.post(`${BASE_URL}/station/v1/status/2/plants/${plantCd}/stations/${stnCd}`, station)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	delete: ({ plantCd, stnCd }) => {
		return client
			.post(`${BASE_URL}/station/v1/status/3/plants/${plantCd}/stations/${stnCd}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
